module.exports = __webpack_public_path__ + "img/element1.983ff0bf.svg";